<footer
  class="flex flex-col lg:flex-row py-8 bg-neutral-800"
  [style.backgroundColor]="colors()?.backgroundColor | contentBuilderColor: 'neutral-800'"
>
  @if (leftBody() && leftBody()?.length) {
    <div class="px-5 lg:px-12 lg:flex lg:justify-between">
      <div class="lg:pr-28 xl:pr-32">
        <app-block-list [blockIdList]="leftBody() ?? []"></app-block-list>
      </div>
    </div>
  }
  @if (columns() && columns()?.length) {
    <div class="px-5 lg:px-12 lg:flex lg:justify-between">
      <div class="grid grid-cols-1 text-center md:grid-cols-4 md:text-left">
        <app-block-list [blockIdList]="columns() ?? []"></app-block-list>
      </div>
    </div>
  }
</footer>
